import { useEffect, useState } from "react";
// import "../assets/styles/editor-v1.css";
import { VideoAnnotator } from "../components/VideoAnnotatorV1";
// import { annotationMockData } from "../assets/constants/video_configs";
import { AlertMessageBox } from "../components/AlertMessage";
import { GradientCircularProgress } from "../components/Loader";
import { add_roi_coordinate, get_roi_coordinate, update_roi_coordinate, delete_roi_coordinate } from "../assets/constants/global_apis";

export default function AnnotatorV1() {
  const [currentlabel, setCurrentLabel] = useState('');
  const [videoUrl, setVideoUrl] = useState("");
  const [timings, setTimings] = useState([]);
  const [videoFrameCount, setvideoFrameCount] = useState(0);
  const [isloaded, setisloaded] = useState(false);
  let [labelsLi, setLabelsLi] = useState([]);
  let [roiList, setroiList] = useState([{
    "height": 100,
    "width": 100,
    "x": 0,
    "y": 0
  }]);
  let [annotationData, setannotationData] = useState({})
  let [urlParams, setUrlParams] = useState({})
  const [showAlertBox, setShowAlertBox] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    Errortype: "Error",
    title: "",
    message: "",
  });


  const openAlertPopup = () => {
    setShowAlertBox(true);
    setTimeout(function () {
      setShowAlertBox(false);
    }, 2000);
  };

  const deleteRoiCoordinates = (roi_id, roiCoordinate) => {
    delete_roi_coordinate(urlParams.collectionID, roi_id).then((response) => {
      getRoiCoordinates()
    })
      .catch(error => {
        console.error(error);
      })
  }

  const updateRoiCoordinates = (roi_id, roiCoordinate) => {
    update_roi_coordinate(urlParams.collectionID, roi_id, roiCoordinate).then((response) => {
      getRoiCoordinates()
    })
      .catch(error => {
        console.error(error);
      })
  }


  const addRoiCoordinates = (roiCoordinate) => {
    add_roi_coordinate(urlParams.collectionID, [
      {
        "roi_coordinates": roiCoordinate
      }
    ]).then((response) => {
      getRoiCoordinates()
    })
      .catch(error => {
        console.error(error);
      })
  }



  const getRoiCoordinates = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const collectionID = params.get('collectionID');
    const backendId = params.get('backendId');
    const collectionPath = params.get('collectionPath');
    get_roi_coordinate(collectionID).then((roiData) => {
      let roiArrayData = getRoiList(roiData)
      setroiList([...roiArrayData]);
      annotationData['roi'] = [...roiArrayData];
      updateAnnotationData(backendId, collectionPath, collectionID, annotationData);
    })
      .catch(error => {
        console.error(error);
      })
  }

  const getRoiList = (roiArray) => {
    let roilist1 = [];
    if (roiArray[0]?.x != 0 || roiArray[0]?.y != 0 || roiArray[0]?.width != 100 || roiArray[0]?.height != 100 || roiArray.length == 0) {
      roilist1.push({
        "height": 100,
        "width": 100,
        "x": 0,
        "y": 0
      })
      roilist1 = [...roilist1, ...roiArray]
    }
    else {
      roilist1 = [...roiArray];
    }
    for (let i = 0; i < roilist1.length; i++) {
      let roi = { ...roilist1[i] };
      roi.x = Math.abs(roi.x)
      roi.y = Math.abs(roi.y)
      roi.width = Math.abs(roi.width)
      roi.height = Math.abs(roi.height)
      roilist1[i] = roi;
    }
    return roilist1;
  }


  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const backendId = params.get('backendId');
    const collectionPath = params.get('collectionPath');
    const collectionID = params.get('collectionID');
    let urlParamVal = {
      backendId: backendId,
      collectionPath: collectionPath,
      collectionID: collectionID
    }
    let storedData = sessionStorage.getItem("sublabelAnnotateData")
      ? JSON.parse(sessionStorage.getItem("sublabelAnnotateData"))
      : undefined;
    setUrlParams(urlParamVal)
    let labelslist = [];
    if (storedData && storedData != undefined && JSON.stringify(urlParamVal) == JSON.stringify(storedData.urlParams)) {
      labelslist = storedData?.labels.map((item, index) => item?.name)
      setVideoUrl(storedData.vidURL);
      setCurrentLabel(storedData.selectedLabel);
      setLabelsLi(labelslist)
      setannotationData(storedData)
      setvideoFrameCount(storedData.details.fps)
      setisloaded(true);
      get_roi_coordinate(collectionID).then((roiData) => {
        let roiArrayData = getRoiList(roiData)
        setroiList([...roiArrayData]);
        storedData['roi'] = [...roiArrayData];
        updateAnnotationData(backendId, collectionPath, collectionID, storedData);
      })
    } else {
      Promise.all([
        fetch(`/api/v1/fetch/stream/${backendId}/${collectionPath}`, {
          method: "GET",
        }).then(async (response) => {
          if (!response.ok) {
            const err = await response.json();
            throw err;
          }
          return response;
        })
          .then((data) => {
            setVideoUrl(data.headers.get('location'));
            setisloaded(true);
          })
          .catch(error => {
            console.error(error);
          }),
        fetch(`/api/v1/annotation/video/${backendId}/${collectionPath.replace(/\//g, "%2F")}?collectionId=${collectionID}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        }).then((response) => response.json())
          .then((data) => {
            let annotateData = data;
            labelslist = annotateData?.labels.map((item, index) => item?.name)
            let label = annotateData?.labels[0]?.name;
            setCurrentLabel(label);
            setLabelsLi(labelslist)
            setannotationData(annotateData)
            setvideoFrameCount(data.details.fps);
            get_roi_coordinate(collectionID).then((roiData) => {
              let roiArrayData = getRoiList(roiData)
              setroiList([...roiArrayData]);
              annotateData['roi'] = [...roiArrayData];
              updateAnnotationData(backendId, collectionPath, collectionID, annotateData);
            })
          })
          .catch(error => {
            console.error(error);
          })
      ])
    }
  }, []);

  const onchangeHandlerLabel = (label, annotatedData) => {
    let indxvl = labelsLi?.indexOf(currentlabel);
    let lablsData = [...annotationData.labels];
    lablsData[indxvl] = {
      id: annotationData.labels[indxvl].id,
      name: annotationData.labels[indxvl].name,
      sublabels: [...annotatedData]
    }
    let annotationDataUpdated = {
      vidURL: videoUrl,
      selectedLabel: label,
      urlParams: { ...urlParams },
      details: { ...annotationData.details },
      labels: lablsData
    }
    sessionStorage.setItem("sublabelAnnotateData", JSON.stringify(annotationDataUpdated));
    window.location.reload();
  };

  const updateAnnotationData = (backendId, collectionPath, collectionID, annotationDataUpdated) => {
    fetch(`/api/v1/annotation/save/video/${backendId}/${collectionPath.replace(/\//g, "%2F")}?collectionId=${collectionID}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        annotationDataUpdated
      )
    }).then(async (response) => {
      if (!response.ok) {
        const error = await response.json();
        throw error;
      }
      return response.json()
    })
  }

  const handleSubmit = (annotatedData, roiListValues) => {
    if (annotationData?.labels != undefined) {
      let indxvl = labelsLi?.indexOf(currentlabel);
      let lablsData = [...annotationData.labels];
      lablsData[indxvl] = {
        id: annotationData.labels[indxvl].id,
        name: annotationData.labels[indxvl].name,
        sublabels: [...annotatedData]
      }
      let roilist1 = [];
      if (!roiListValues || roiListValues.length == 0 || roiListValues == undefined) {
        if (!roiList || roiList.length == 0 || roiList[0].x != 0 || roiList[0].y != 0 || roiList[0].width != 100 || roiList[0].height != 100) {
          roilist1.push({
            "height": 100,
            "width": 100,
            "x": 0,
            "y": 0
          })
        }
        roilist1 = [...roilist1, ...roiList]
      }
      else if (roiListValues.length > 0) {
        roilist1 = [...roiListValues]
      }
      else {
        roilist1 = [...roilist1, ...roiList]
      }
      for (let i = 0; i < roilist1.length; i++) {
        let roi = { ...roilist1[i] };
        roi.x = Math.abs(roi.x)
        roi.y = Math.abs(roi.y)
        roi.width = Math.abs(roi.width)
        roi.height = Math.abs(roi.height)
        roilist1[i] = roi;
      }
      let annotationDataUpdated = {
        details: { ...annotationData.details },
        labels: lablsData,
        roi: roilist1 ? roilist1 : []
      }
      const { backendId, collectionPath, collectionID } = urlParams;
      updateAnnotationData(backendId, collectionPath, collectionID, annotationDataUpdated);
      setAlertMessage({
        Errortype: "Success",
        title: "Success",
        message: "annotation meta file exported",
      });
      openAlertPopup();
    }
  };

  //   const handleFileChange = (event) => {
  //     const file = event?.target?.files[0];
  //     if (file) {
  //       const url = URL.createObjectURL(file);
  //       setVideoUrl(url);
  //       sessionStorage.setItem("videoUrl", url);
  //     }
  //   };

  const renderEditor = () => {
    return (
      <>
        {isloaded && Object.keys(annotationData).length > 0 && annotationData?.labels.length > 0 &&
          annotationData?.labels.map((item, index) => {
            return (
              <div key={`video_editor_parent_container${index}`}>
                {item?.name == currentlabel ? (
                  <VideoAnnotator
                    videoUrl={videoUrl}
                    urlParams={urlParams}
                    timings={timings}
                    setTimings={setTimings}
                    onchangeHandlerLabel={onchangeHandlerLabel}
                    currentlabel={currentlabel}
                    labelsLi={labelsLi}
                    handleSubmit={handleSubmit}
                    addRoiCoordinates={addRoiCoordinates}
                    videoFrameCount={videoFrameCount}
                    updateRoiCoordinates={updateRoiCoordinates}
                    deleteRoiCoordinates={deleteRoiCoordinates}
                    annotationData={{
                      video: annotationData?.video,
                      id: annotationData?.id,
                      labels: [item],
                    }}
                    roiList={roiList}
                    setroiList={setroiList}
                  />
                ) : (
                  ""
                )}
              </div>
            );
          })}
      </>
    );
  };

  return (
    <div className="overallVideoAnnotatorContainer">
      {/* <input type='file' accept='video/*' onChange={handleFileChange} /> */}
      {videoUrl != "" ? renderEditor() : <div className="initialLoader"> <GradientCircularProgress /></div>}
      <div className='annotatesubmitcontainer'>
        <AlertMessageBox
          showAlertBox={showAlertBox}
          setShowAlertBox={setShowAlertBox}
          alertMessage={alertMessage}
        />
      </div>
    </div>
  );
}

